export default class CustomFieldOption
{
  constructor(names, price) 
  {
    this.names = names; // {} instead of array to support stringify
    this.price = price;
  }    

  isValid()
  {
    var result = true;    
    
    for (const [key, value] of Object.entries(this.names)) {
      if(!value)
      {
        result = false;
        break;
      }
    }

    if(this.price == "")
    {
      this.price = null
    }
    
    // if(result) result = this.price;
    
    return result;
  }
}